// extracted by mini-css-extract-plugin
export default {"main_css_us":"InputCheckbox_main_css_us__OZCMp","main_css_jp":"InputCheckbox_main_css_jp__vZDr9"};